import React, { useCallback } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { injectIntl, FormattedMessage } from 'react-intl'

import { getError } from '../utility/formValidation'
import { findLocalized } from '../utils'
import Visa from '../images/svg-icons/cc-visa-brands.svg'
import Mastercard from '../images/svg-icons/cc-mastercard-brands.svg'
import AmericanExpress from '../images/svg-icons/cc-amex-brands.svg'
import CreditCard from '../images/svg-icons/credit-card-regular.svg'


const ModalitaPagamentoReport = ({ payment, onChange, errors, locale }) => {
  const error = getError('payment', errors);
  const errorClass = error ? 'field--error' : '';
  const changeToCard = useCallback(() => onChange({ target: { name: 'payment', value: 'card' } }), [onChange]);
  return (
    <StaticQuery
      query={graphql`
        query {
          allModalitaPagamentoYaml{
            edges{
              node{
                title
                bonifico
                infoReport
                lang
              }
            }
          }
        }
      `}
      render={data => {
        const { title, bonifico, infoReport } = findLocalized(data.allModalitaPagamentoYaml, locale);
        return (
          <div>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <div className={`field ${errorClass}`}>
                  <div className="field__title">{title}</div>
                  <form>
                    {/* The <div> element has a child <input> element that allows keyboard interaction */}
                    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
                    <div className="field__wrapper" onClick={changeToCard}>
                      <label htmlFor="report-payment-type-card" className="field__label field__radio">
                        <div className="field__textwrapper">
                          <input id="report-payment-type-card" type="radio" name="payment" value="card"
                            checked={payment === 'card'} onChange={onChange} />
                          <span className="checkmark"></span>
                        </div>
                      </label>
                      <Visa className="icon-card" />
                      <Mastercard className="icon-card" />
                      <AmericanExpress className="icon-card" />
                      <CreditCard className="icon-card" />
                    </div>
                    <label htmlFor="report-payment-type-transfer" className="field__label field__radio">
                      <div className="field__textwrapper">
                        <input id="report-payment-type-transfer" type="radio" name="payment" value="transfer"
                          checked={payment === 'transfer'} onChange={onChange} />
                        <span className="checkmark"></span>
                      </div>
                      {bonifico}
                    </label>
                  </form>
                  {!!error && !!error.message && <span className="field__message">
                    <FormattedMessage id={error.message} defaultMessage={error.message}/>
                  </span>}
                </div>
              </div>
            </div>
            {payment === 'transfer' && (
              <div className="row">
                <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2" dangerouslySetInnerHTML={{__html: infoReport}}></div>
              </div>
            )}
          </div>
        )
      }}
    />
  )
};

export default injectIntl(ModalitaPagamentoReport);